const zhCN = {
  backBtn: '返回',
  submitBtn: '提交',

  strangerWarningTitle: '陌生人预警',
  strangerWarning: '是否启用陌生人预警',
  strangerWarningFlash: '是否启用陌生人预警提示闪烁',
  strangerWarningVoice: '是否启用陌生人预警提示声音',

  blacklistWarningTitle: '黑名单预警',
  blacklistWarning: '是否启用黑名单预警',
  blacklistWarningFlash: '是否启用黑名单预警提示闪烁',
  blacklistWarningVoice: '是否启用黑名单预警提示声音',

  temperatureAlarmTitle: '体温异常报警',
  temperatureAlarm: '是否启用体温异常报警',
  temperatureAlarmFlash: '是否启用体温异常报警提示闪烁',
  temperatureAlarmVoice: '是否启用体温异常报警提示声音',

  deviceAbnormalAlarmTitle: '设备异常报警',

  networkAbnormalAlarm: '是否启用网络异常报警',
  networkAbnormalAlarmFlash: '是否启用网络异常报警提示闪烁',
  networkAbnormalAlarmVoice: '是否启用网络异常报警提示声音',

  abnormalStateAlarm: '是否启用状态异常报警',
  abnormalStateAlarmFlash: '是否启用状态异常报警提示闪烁',
  abnormalStateAlarmVoice: '是否启用状态异常报警提示声音',

  selfCheckAbnormalAlarm: '是否启用自检异常报警',
  selfCheckAbnormalAlarmFlash: '是否启用自检异常报警提示闪烁',
  selfCheckAbnormalAlarmVoice: '是否启用自检异常报警提示声音',

  option_true: '是',
  option_false: '否'
}
const enUS = {
  backBtn: 'Back',
  submitBtn: 'Submit',

  strangerWarningTitle: 'Stranger Warning',
  strangerWarning: 'Enable Stranger Warning',
  strangerWarningFlash: 'Enable Stranger Warning Flash',
  strangerWarningVoice: 'Enable Stranger Warning Voice',

  blacklistWarningTitle: 'Blacklist warning',
  blacklistWarning: 'Enable Blacklist Warning',
  blacklistWarningFlash: 'Enable Blacklist Warning Flash',
  blacklistWarningVoice: 'Enable Blacklist Warning Voice',

  temperatureAlarmTitle: 'Temperature Alarm',
  temperatureAlarm: 'Enable Temperature Alarm',
  temperatureAlarmFlash: 'Enable Temperature Alarm Flash',
  temperatureAlarmVoice: 'Enable Temperature Alarm Voice',

  deviceAbnormalAlarmTitle: 'Device Abnormal Alarm',

  networkAbnormalAlarm: 'Enable Network Abnormal Alarm',
  networkAbnormalAlarmFlash: 'Enable Network Abnormal Alarm Flash',
  networkAbnormalAlarmVoice: 'Enable Network Abnormal Alarm Voice',

  abnormalStateAlarm: 'Enable Abnormal State Alarm',
  abnormalStateAlarmFlash: 'Enable Abnormal State Alarm Flash',
  abnormalStateAlarmVoice: 'Enable Abnormal State Alarm Voice',

  selfCheckAbnormalAlarm: 'Enable Self-Check Abnormal Alarm',
  selfCheckAbnormalAlarmFlash: 'Enable Self-Check Abnormal Alarm Flash',
  selfCheckAbnormalAlarmVoice: 'Enable Self-Check Abnormal Alarm Voice',

  option_true: 'True',
  option_false: 'False'
}

export default { zhCN, enUS }